// Importando os layouts principais
import Dashboard from "layouts/dashboard";
import Lancamentos from "layouts/lancamentos";
import Categorias from "layouts/categorias";
import Cartoes from "layouts/cartoes";
import LimiteGastos from "layouts/limiteGastos";
import Metas from "layouts/metas";
import Investimentos from "layouts/investimentos";
import Relatorios from "layouts/relatorios";
import Consultoria from "layouts/consultoria";
import MinhaConta from "layouts/minhaConta";
import DividasPage from "layouts/dividas"; // Importando a página de dívidas
import React from "react";

// Importando as telas de autenticação
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import ResetPassword from "layouts/authentication/reset-password";
import ConfirmResetPassword from "layouts/authentication/ConfirmResetPassword";

// Importando os layouts específicos para Consultor e Administrador
import PainelConsultor from "layouts/PainelConsultor";
import PainelAdmin from "layouts/PainelAdmin";

// Ícones do Material UI
import Icon from "@mui/material/Icon";

const routes = [
  {
    type: "route",
    name: "Sign In",
    key: "sign-in",
    route: "/authentication/sign-in",
    component: <SignIn />,
    allowedRoles: ["cliente", "consultor", "admin"],
  },
  {
    type: "route",
    name: "Sign Up",
    key: "sign-up",
    route: "/authentication/sign-up",
    component: <SignUp />,
    allowedRoles: ["cliente", "consultor", "admin"],
  },
  {
    type: "route",
    name: "Reset Password",
    key: "reset-password",
    route: "/authentication/reset-password",
    component: <ResetPassword />,
    allowedRoles: ["cliente", "consultor", "admin"],
  },
  {
    type: "route",
    name: "Confirm Reset Password",
    key: "confirm-reset-password",
    route: "/authentication/confirm-reset-password",
    component: <ConfirmResetPassword />,
    allowedRoles: ["cliente", "consultor", "admin"],
  },
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
    allowedRoles: ["cliente", "consultor", "admin"],
  },
  {
    type: "collapse",
    name: "Lançamentos",
    key: "lancamentos",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/lancamentos",
    component: <Lancamentos />,
    allowedRoles: ["cliente", "consultor", "admin"],
  },
  {
    type: "collapse",
    name: "Categorias",
    key: "categorias",
    icon: <Icon fontSize="small">category</Icon>,
    route: "/categorias",
    component: <Categorias />,
    allowedRoles: ["cliente", "consultor", "admin"],
  },
  {
    type: "collapse",
    name: "Cartões",
    key: "cartoes",
    icon: <Icon fontSize="small">credit_card</Icon>,
    route: "/cartoes",
    component: <Cartoes />,
    allowedRoles: ["cliente", "consultor", "admin"],
  },
  {
    type: "collapse",
    name: "Planejamento",
    key: "limite-gastos",
    icon: <Icon fontSize="small">account_balance_wallet</Icon>,
    route: "/Plajejamento",
    component: <LimiteGastos />,
    allowedRoles: ["cliente", "consultor", "admin"],
  },
  {
    type: "collapse",
    name: "Metas",
    key: "metas",
    icon: <Icon fontSize="small">flag</Icon>,
    route: "/metas",
    component: <Metas />,
    allowedRoles: ["cliente", "consultor", "admin"],
  },
  {
    type: "collapse",
    name: "Investimentos",
    key: "investimentos",
    icon: <Icon fontSize="small">trending_up</Icon>,
    route: "/investimentos",
    component: <Investimentos />,
    allowedRoles: ["cliente", "consultor", "admin"],
  },
  {
    type: "collapse",
    name: "Relatórios",
    key: "relatorios",
    icon: <Icon fontSize="small">assessment</Icon>,
    route: "/relatorios",
    component: <Relatorios />,
    allowedRoles: ["cliente", "consultor", "admin"],
  },
  {
    type: "hidden",
    name: "Consultoria",
    key: "consultoria",
    icon: <Icon fontSize="small">support</Icon>,
    route: "/consultoria",
    component: <Consultoria />,
    allowedRoles: ["cliente", "consultor", "admin"],
  },
  {
    type: "collapse",
    name: "Painel do Consultor",
    key: "painel-consultor",
    icon: <Icon fontSize="small">supervisor_account</Icon>,
    route: "/painel-consultor",
    component: <PainelConsultor />,
    allowedRoles: ["consultor", "admin"],
  },
  {
    type: "collapse",
    name: "Painel do Administrador",
    key: "painel-admin",
    icon: <Icon fontSize="small">admin_panel_settings</Icon>,
    route: "/painel-admin",
    component: <PainelAdmin />,
    allowedRoles: ["admin"],
  },

  {
    type: "route",
    name: "Minha Conta",
    key: "minha-conta",
    route: "/minha-conta",
    component: <MinhaConta />,
    allowedRoles: ["cliente", "consultor", "admin"],
  },
];

export default routes;
